import axios, { 
  AxiosError, 
  AxiosInstance, 
  AxiosResponse,
  InternalAxiosRequestConfig 
} from 'axios';



const BASE_URL = import.meta.env.VITE_API_URL || "https://bff.tuespacioyastas.com.mx/";
const TIMEOUT = 604800;



const api: AxiosInstance = axios.create({
  baseURL: BASE_URL,
  timeout: TIMEOUT,
  withCredentials: true,
  headers: {
    'Content-Type': 'application/json',
  },
});



api.interceptors.request.use(
  (config: InternalAxiosRequestConfig) => {
    return config;console
  },
  (error: AxiosError) => {
    return Promise.reject(error);
  }
);


api.interceptors.response.use(
  (response: AxiosResponse) => {
    return response;
  },
  (error: AxiosError<{ code?: string; message?: string }>) => {
    const status = error.response?.status;
    const errorMessage = error.response?.data?.message;

    switch (status) {
      case 401:
        if (!window.location.pathname.includes('/login')) {
          sessionStorage.setItem('redirectAfterLogin', window.location.pathname);
          window.location.href = '/login';
        }
        break;
      case 403:
        console.warn('Access forbidden');
        break;
      case 404:
        console.warn('Resource not found');
        break;
      case 500:
      case 502:
      case 503:
        console.error('Server error');
        break;
      default:
        if (!status) {
          console.error('Network error - check connection');
        }
    }

    return Promise.reject(error);
  }
);



export const getErrorMessage = (error: unknown): string => {
  if (axios.isAxiosError(error)) {
    return error.response?.data?.message || error.message || 'Error desconocido';
  }
  if (error instanceof Error) {
    return error.message;
  }
  return 'Error desconocido';
};

export const isAuthError = (error: unknown): boolean => {
  if (axios.isAxiosError(error)) {
    return error.response?.status === 401;
  }
  return false;
};

export const isForbiddenError = (error: unknown): boolean => {
  if (axios.isAxiosError(error)) {
    return error.response?.status === 403;
  }
  return false;
};

export default api;